/**
 * GA4 Analytics utilities
 * Fires events to Google Analytics 4 via gtag
 */

type GtagEventParams = {
  event_category?: string
  event_label?: string
  value?: number
  [key: string]: string | number | undefined
}

/**
 * Fire a GA4 event
 */
export function trackEvent(eventName: string, params?: GtagEventParams): void {
  if (typeof window !== 'undefined' && 'gtag' in window) {
    (window as any).gtag('event', eventName, params)
  }
}

/**
 * Track CTA button clicks
 */
export function trackCtaClick(label: string): void {
  trackEvent('cta_click', {
    event_category: 'engagement',
    event_label: label,
  })
}

/**
 * Track page views for key pages (supplements automatic page_view)
 */
export function trackPageView(pageName: string): void {
  trackEvent(`${pageName}_view`, {
    event_category: 'navigation',
    event_label: pageName,
  })
}

/**
 * Track form interactions
 */
export function trackFormStart(): void {
  trackEvent('form_start', {
    event_category: 'engagement',
    event_label: 'Contact Form',
  })
}
